export { ChevronDoubleUp as default } from './ChevronDoubleUp';
